if (!customElements.get('lookbook-card')) {
  customElements.define(
    'lookbook-card',
    class LookbookCard extends ModalComponent {
      constructor() {
        super();

        this.card = this.closest('.lbcard');

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = () => {
          this.removeAttribute('open');
          this.unlockPageScroll();
          this.releaseHeaderStabilizer(true);
          document.body.classList.remove(this.classes.show, 'lookbook-card-modal-open');
          document.documentElement.classList.remove('lookbook-card-modal-open', 'lookbook-card-header-stable');
        };
      }

      get isLockingNeeded() {
        return FoxTheme.config.mqlMobile;
      }
    
      get requiresBodyAppended() {
        return FoxTheme.config.mqlMobile;
      }

      prepareToShow() {
        super.prepareToShow();

        this.card.classList.add('is-open');
        this.headerStabilizerAbortController?.abort();
        this.wasHeaderPinned = document.body.classList.contains('header-pinned');
        document.body.classList.add('header-pinned', 'lookbook-card-header-stable');
        document.documentElement.classList.add('lookbook-card-header-stable');
        this.lockPageScroll();
        document.body.classList.add('lookbook-card-modal-open');
        document.documentElement.classList.add('lookbook-card-modal-open');
      }

      lockPageScroll() {
        if (!FoxTheme.config.mqlMobile || this.pageScrollLocked) return;

        this.pageScrollLocked = true;
        this.scrollLockAbortController = new AbortController();
        const lockSignal = this.scrollLockAbortController.signal;
        const getScrollableModalBody = (target) => target.closest('.lbcard__popup-body');
        const shouldPreventScrollChaining = (scroller, deltaY) => {
          if (!scroller) return true;

          const isScrollingUp = deltaY < 0;
          const isScrollingDown = deltaY > 0;
          const isAtTop = scroller.scrollTop <= 0;
          const isAtBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1;

          return (isScrollingUp && isAtTop) || (isScrollingDown && isAtBottom);
        };
        const preventWheelScrollChaining = (event) => {
          if (shouldPreventScrollChaining(getScrollableModalBody(event.target), event.deltaY)) {
            event.preventDefault();
          }
        };
        const recordTouchPosition = (event) => {
          this.lastTouchY = event.touches[0]?.clientY || 0;
        };
        const preventTouchScrollChaining = (event) => {
          const currentTouchY = event.touches[0]?.clientY || 0;
          const deltaY = this.lastTouchY - currentTouchY;
          this.lastTouchY = currentTouchY;

          if (shouldPreventScrollChaining(getScrollableModalBody(event.target), deltaY)) {
            event.preventDefault();
          }
        };

        document.addEventListener('wheel', preventWheelScrollChaining, { passive: false, signal: lockSignal });
        document.addEventListener('touchstart', recordTouchPosition, { passive: true, signal: lockSignal });
        document.addEventListener('touchmove', preventTouchScrollChaining, { passive: false, signal: lockSignal });
      }

      unlockPageScroll() {
        if (!this.pageScrollLocked) return;

        this.pageScrollLocked = false;
        if (this.scrollLockAbortController) {
          this.scrollLockAbortController.abort();
          this.scrollLockAbortController = null;
        }
        this.lastTouchY = 0;
      }

      releaseHeaderStabilizer(immediate = false) {
        const release = () => {
          this.headerStabilizerAbortController?.abort();
          this.headerStabilizerAbortController = null;
          document.body.classList.remove('lookbook-card-header-stable');
          document.documentElement.classList.remove('lookbook-card-header-stable');
          if (this.wasHeaderPinned === false) document.body.classList.remove('header-pinned');
          this.wasHeaderPinned = null;
        };

        if (immediate) {
          release();
          return;
        }

        this.headerStabilizerAbortController?.abort();
        this.headerStabilizerAbortController = new AbortController();
        const releaseOptions = { once: true, passive: true, signal: this.headerStabilizerAbortController.signal };
        window.addEventListener('scroll', release, releaseOptions);
        document.addEventListener('touchstart', release, releaseOptions);
        document.addEventListener('pointerdown', release, releaseOptions);
        document.addEventListener('wheel', release, releaseOptions);
      }

      handleAfterHide() {
        super.handleAfterHide();

        this.card.classList.remove('is-open');
        this.unlockPageScroll();
        document.body.classList.remove('lookbook-card-modal-open');
        document.documentElement.classList.remove('lookbook-card-modal-open');
        this.releaseHeaderStabilizer();
      }
    }
  );
}

if (!customElements.get('lookbook-card-wrapper')) {
  customElements.define(
    'lookbook-card-wrapper',
    class LookbookCardWrapper extends HTMLElement {
      constructor() {
        super();
      }

      get video() {
        return this.querySelector('video-element');
      }

      connectedCallback() {
        if (!this.video) return;

        this.addEventListener('mouseleave', this.handleMouseInteraction.bind(this, 'leave'));
        this.addEventListener('mouseenter', this.handleMouseInteraction.bind(this, 'enter'));
      }

      disconnectedCallback() {
        this.removeEventListener('mouseleave');
        this.removeEventListener('mouseenter');
      }

      handleMouseInteraction(type, event) {
        if (type === 'enter') {
          this.classList.add('is-hovering');
          this.video.play();
        } else {
          this.classList.remove('is-hovering');
          this.video.pause();
        }
      }
    }
  );
}